(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      if (!this.header) return;

      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      this.headerBounds = {};
      this.currentScrollTop =
        window.pageYOffset || document.documentElement.scrollTop || 0;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.autoScrollLock = false;
      this.autoScrollTimeout = null;

      this.setHeaderHeight();
      window
        .matchMedia('(max-width: 990px)')
        .addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.hideHeaderOnScrollUp = this.hideHeaderOnScrollUp.bind(this);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    setHeaderHeight() {
      if (!this.header) return;
      document.documentElement.style.setProperty(
        '--header-height',
        `${this.header.offsetHeight}px`
      );
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      if (!this.header) return;

      const observer = new IntersectionObserver((entries, obs) => {
        this.headerBounds = entries[0].intersectionRect || {};
        obs.disconnect();
      });

      observer.observe(this.header);
    }

    hideHeaderOnScrollUp() {
      if (this.headerIsAlwaysSticky || !this.header) return;

      this.header.classList.add('fp-header-no-animate');

      this.autoScrollLock = true;
      this.hide();

      clearTimeout(this.autoScrollTimeout);
      this.autoScrollTimeout = setTimeout(() => {
        this.autoScrollLock = false;
        this.header.classList.remove('fp-header-no-animate');
      }, 800);
    }

    onScroll() {
      if (!this.header) return;

      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop || 0;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (this.autoScrollLock) {
        this.hide();
        this.currentScrollTop = scrollTop;
        return;
      }

      const isMobile = window.innerWidth <= 989;
      const headerBottom = isMobile
        ? 0
        : this.headerBounds.bottom || this.header.offsetHeight || 0;

      const passedHeader = isMobile ? scrollTop > 0 : scrollTop > headerBottom;

      if (!passedHeader) {
        this.header.classList.remove('scrolled-past-header');
        this.reset();
        this.currentScrollTop = scrollTop;
        return;
      }

      this.header.classList.add('scrolled-past-header');

      if (scrollTop > this.currentScrollTop) {
        if (!this.headerIsAlwaysSticky) this.hide();
      } else if (scrollTop < this.currentScrollTop) {
        if (!this.headerIsAlwaysSticky) this.reveal();
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (!this.header || this.headerIsAlwaysSticky) return;
      this.header.classList.add(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky'
      );
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (!this.header || this.headerIsAlwaysSticky || this.autoScrollLock) return;
      this.header.classList.add(
        'shopify-section-header-sticky',
        'animate'
      );
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (!this.header || this.headerIsAlwaysSticky) return;
      this.header.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate'
      );
    }

    closeMenuDisclosure() {
      if (!this.header) return;
      this.disclosures =
        this.disclosures || this.header.querySelectorAll('header-menu');
      if (!this.disclosures) return;
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      if (!this.header) return;
      this.searchModal =
        this.searchModal || this.header.querySelector('details-modal');
      if (!this.searchModal) return;
      this.searchModal.close(false);
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  (() => {
    const DESKTOP_BREAKPOINT = 990;
    const ENTER_EVENT =
      'onpointerenter' in window ? 'pointerenter' : 'mouseenter';
    const LEAVE_EVENT =
      'onpointerleave' in window ? 'pointerleave' : 'mouseleave';

    function isDesktop() {
      return window.innerWidth >= DESKTOP_BREAKPOINT;
    }

    function enableHover(details) {
      if (details._fpHoverBound) return;

      if (details.open) details.open = false;

      const handleEnter = (event) => {
        if (!isDesktop()) return;
        if (event.pointerType && event.pointerType !== 'mouse') return;
        details.open = true;
      };

      const handleLeave = (event) => {
        if (!isDesktop()) return;
        if (event.pointerType && event.pointerType !== 'mouse') return;
        details.open = false;
      };

      details.addEventListener(ENTER_EVENT, handleEnter);
      details.addEventListener(LEAVE_EVENT, handleLeave);

      details._fpHoverBound = { handleEnter, handleLeave };
    }

    function disableHover(details) {
      const bound = details._fpHoverBound;
      if (!bound) return;

      details.removeEventListener(ENTER_EVENT, bound.handleEnter);
      details.removeEventListener(LEAVE_EVENT, bound.handleLeave);
      delete details._fpHoverBound;

      details.open = false;
    }

    function refreshHoverMenus() {
      const menus = document.querySelectorAll('.header__inline-menu header-menu');
      if (!menus.length) {
        document.body.classList.remove('fp-menu-ready');
        return;
      }

      let anyHoverEnabled = false;

      menus.forEach((menu) => {
        const detailsList = menu.querySelectorAll('details');

        detailsList.forEach((details) => {
          if (isDesktop()) {
            enableHover(details);
            anyHoverEnabled = true;
          } else {
            disableHover(details);
          }
        });
      });

      if (anyHoverEnabled) {
        document.body.classList.add('fp-menu-ready');
      } else {
        document.body.classList.remove('fp-menu-ready');
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', refreshHoverMenus);
    } else {
      refreshHoverMenus();
    }

    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(refreshHoverMenus, 150);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
